// extracted by mini-css-extract-plugin
module.exports = {"title":"GenerateLink_title__T7Mh_","link":"GenerateLink_link__I6Z3U"};